import React from 'react';

const ImageUpload = ({ 
  annotatedImageFiles, 
  imageDragOver, 
  onImageSelect, 
  onImageDrop, 
  onImageDragOver, 
  onImageDragLeave, 
  onRemoveImageFile 
}) => {
  const formatFileSize = (bytes) => {
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
  };

  return (
    <div className="form-card">
      <div className="card-header">
        <h3>🖼️ Upload Annotated Images</h3>
        <span className="optional-badge">Optional</span>
      </div>
      <div className="card-content">
        <div
          className={`modern-upload-area image-upload ${imageDragOver ? 'dragover' : ''}`}
          onDrop={onImageDrop}
          onDragOver={onImageDragOver}
          onDragLeave={onImageDragLeave}
        >
          <div className="upload-content">
            <div className="upload-icon">🖼️</div>
            <h4>Drop multiple image files here</h4>
            <p>or click to browse and select multiple files</p>
            <input
              type="file"
              accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
              multiple
              onChange={onImageSelect}
              style={{ display: 'none' }}
              id="imageInput"
            />
            <label htmlFor="imageInput" className="upload-btn secondary">
              Choose Multiple Images
            </label>
          </div>
          <div className="upload-info">
            <span>🎨 JPG, PNG, GIF, WebP supported</span>
            <span>📏 Up to 5MB each</span>
            <span>📊 Multiple files supported</span>
          </div>
        </div>

        {annotatedImageFiles.length > 0 && (
          <div className="file-preview">
            <div className="preview-header">
              <h4>🖼️ Selected Images ({annotatedImageFiles.length})</h4>
              <div className="total-size">
                Total: {(annotatedImageFiles.reduce((total, file) => total + file.size, 0) / 1024 / 1024).toFixed(2)} MB
              </div>
            </div>
            <div className="image-grid">
              {annotatedImageFiles.map((file, index) => (
                <div key={`image-${index}-${file.name}`} className="image-card">
                  <div className="image-number">#{index + 1}</div>
                  <div className="image-preview">
                    <img 
                      src={URL.createObjectURL(file)} 
                      alt={file.name}
                      onLoad={(e) => URL.revokeObjectURL(e.target.src)}
                    />
                  </div>
                  <div className="image-details">
                    <span className="image-name" title={file.name}>
                      {file.name.length > 20 ? `${file.name.substring(0, 20)}...` : file.name}
                    </span>
                    <span className="image-size">
                      {formatFileSize(file.size)}
                    </span>
                  </div>
                  <button
                    className="remove-btn"
                    onClick={() => onRemoveImageFile(index)}
                    title="Remove image"
                    aria-label={`Remove ${file.name}`}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;